.container {
  display: flex;
  align-items: center;
  gap: 4px;
}

.title {
  margin: 0;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  gap: 6px;

  &:is(h1, h2, h3, h4, h5, h6) {
    margin-bottom: 0;
  }

  &.level-6:is(h5) {
    font-size: var(--md-font-size);
  }

  &.level-7:is(h5) {
    font-size: var(--sm-font-size);
  }

  &.icon {
    display: flex;
    gap: 4px;
    align-items: center;
  }

  &.no__capitalize {
    text-transform: none;
  }
}
